import setupDeprecationWorkflow from 'ember-cli-deprecation-workflow';

/******************************************************************************
 *
 * Our objective is to progress each Ember deprecation warning through:
 *    Logged → Silenced → Thrown → Deleted
 *
 * For more information on how Ember deprecations fit into the Ember v4 upgrade
 * SEE:https://hashicorp.atlassian.net/browse/HCE-30
 *
 *
 * How to resolve Ember deprecation warnings:
 * ------------------------------------------
 * 1. change the override's `handler` property to from ~`silence`~ to `throw`
 * 2. commit your change, and push to git remote so CI can run all the tests
 * 3. see what fails in CI after the deprecated code is made to throw
 * 4. find a way to fix and validate the tests by running the UI locally
 *    and triggering the fixed code locally
 *    (NOTE: deprecated code must be run, static analysis won't catch in build)
 * 5. run through any effected workflows, or anything related locally
 * 6. once everything works in CI, and manual QA locally you're done
 * 7. we'll remove the deprecation override AFTER we upgrade to Ember v4
 *    (until then, throwing in CI will help to avoid regressions)
 *
 * SEE: https://github.com/mixonic/ember-cli-deprecation-workflow#workflow
 *
 *
 * After the Ember v4 upgrade, it would be ideal to configure strict 'catch all'
 * deprecation settings, in order to reduce the amount of refactoring for the
 * next major Ember upgrade we undertake in Cloud UI.
 *
 * SEE: https://github.com/mixonic/ember-cli-deprecation-workflow#catch-all
 *
 *
 ******************************************************************************/

setupDeprecationWorkflow({
  throwOnUnhandled: false,
  workflow: [
    // Ember
    {
      handler: 'silence',
      matchId: 'ember-engines.addon-test-support.engine-resolver-for',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-env-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-onerror-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import---loader-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-destroy-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import--register-destructor-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import--is-destroyed-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-test-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import--set-classic-decorator-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import--is-destroying-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-service-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-rsvp-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-libraries-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import--capture-render-tree-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-assert-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'ember-test-waiters-legacy-module-name',
    },
    {
      handler: 'silence',
      matchId: 'importing-inject-from-ember-service',
    },
    // HDS
    {
      handler: 'silence',
      matchId: 'hds.dropdown.list-item.interactive',
    },
    {
      handler: 'silence',
      matchId: 'hds.components.sidenav',
    },
  ],
});
